import { LucideIcon } from "lucide-react";
import { FeatureCard } from "./FeatureCard";

interface Feature {
  icon: LucideIcon;
  title: string;
  description: string;
}

interface FeaturesGridProps {
  title: string;
  description: string;
  features: Feature[];
}

export const FeaturesGrid = ({ title, description, features }: FeaturesGridProps) => {
  return (
    <section className="py-12 px-4 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 animate-fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6">
            {title}
          </h2>
          <p className="text-lg text-neutral max-w-2xl mx-auto">
            {description}
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={`${0.2 * (index + 1)}s`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};